.drip-sequences-list-container {
    /* Needed for list view */
    position: relative;
    flex: 1;
}

.drip-sequence-list-item-container:not(:last-child) {
    padding-bottom: 16px;
}
